import { DashboardsApiService } from './dashboards-api.service';

export default angular
  .module('sfMobile.services.dashboards', ['sfMobile.services.pov'])
  .service('dashboardsApiService', DashboardsApiService).name;
